export const GetCollectionMissionInterestIntervalList = [    
    { value: "last_month", text: "LastMonth" },
    { value: "last_seven", text: "LastSeven" },
    { value: "this_month", text: "ThisMonth" },
    { value: "user_defined", text: "UserDefined" },    
    { value: "recent_missing_data", text: "RecentMissingData" },
    { value: "ytd_missing_data", text: "YearToDateMissing" },   
    
]